var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BForm, BFormInput, BModal } from "bootstrap-vue";
import { ref } from "vue";
import { updateWorkflow } from "@/components/Workflow/workflows.services";
import { Toast } from "@/composables/toast";
import localize from "@/utils/localization";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRename',
    props: {
        id: null,
        name: null,
        show: { type: Boolean }
    },
    emits: ["close", "onRename"],
    setup(__props, { emit }) {
        const props = __props;
        const nameModel = ref(props.name);
        const workflowNameInput = ref(null);
        function onRename(newName) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield updateWorkflow(props.id, { name: newName });
                    Toast.success("Workflow renamed");
                }
                catch (e) {
                    Toast.error("Failed to rename workflow");
                }
                finally {
                    emit("close");
                }
            });
        }
        return { __sfc: true, props, emit, nameModel, workflowNameInput, onRename, BForm, BFormInput, BModal, localize, Heading };
    }
});
